import { render, staticRenderFns } from "./ExamQuestionTypePicker.vue?vue&type=template&id=130ab85e&"
import script from "./ExamQuestionTypePicker.vue?vue&type=script&lang=js&"
export * from "./ExamQuestionTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports